// Angular
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
import { SelectOptionsService } from '@app/shared/services/select-options.service'
import { EmailAddress } from '@app/modules/email-address/email-address.model'
import { EmailAddressFormService } from '@app/modules/email-address/email-address-form.service'
import { DeleteIdFormService } from '@app/modules/delete-id/delete-id-form.service'
import { ValidationService } from '@app/shared/services/validation.service'

@Component({
  selector: 'app-email-addresses-form-array',
  templateUrl: './email-addresses-form-array.component.html'
})

export class EmailAddressesFormArrayComponent implements OnInit, OnDestroy {

  /**
   * Display page
   */
  public display: boolean

  /**
   * Heading text
   */
  @Input() headingText: string

  /**
   * Button text
   */
  @Input() buttonText: string

  /**
   * Main form
   */
  @Input() mainForm: FormGroup

  /**
   * Main form change
   */
  @Output() mainFormChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>()

  /**
   * Constructor
   */
  public constructor (
    public selectOptionsService: SelectOptionsService,
    private emailAddressFormService: EmailAddressFormService,
    private deleteIdFormService: DeleteIdFormService,
    public validationService: ValidationService
  ) {}

  /**
   * On destroy
   */
  public ngOnDestroy (): void {}

  /**
   * On init
   */
  public ngOnInit (): void {
    this.display = true
  }

  /**
   * Add
   */
  public add (): void {
    const control: FormArray = this.mainForm.get('emailAddresses') as FormArray
    const emailAddress: EmailAddress = new EmailAddress()
    const form: FormGroup = this.emailAddressFormService.getForm(emailAddress, 'new')
    control.push(form)
    this.mainForm.markAsDirty()
  }

  /**
   * Remove
   *
   * @param {FormGroup} item EmailAddress
   */
  public remove (item: FormGroup): void {
    const control: FormArray = this.mainForm.get('emailAddresses') as FormArray
    const index: number = control.controls.findIndex(x => x === item)
    const emailAddress: EmailAddress = new EmailAddress(item.value)

    if (emailAddress.uuid) {
      // Mark it for delete.
      const deleted: FormArray = this.mainForm.get('emailAddresses' + 'Deleted') as FormArray
      deleted.push(this.deleteIdFormService.getForm({ uuid: emailAddress.uuid }))
    }

    control.removeAt(index)
    this.mainForm.markAsDirty()
  }

}
